import React from "react";
import { Reveal } from "../components/Reveal";
import PricingCards from "../components/PricingCards";

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      {/* Hero */}
      <section className="bg-charcoal pt-40 pb-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <span className="font-display text-sm uppercase tracking-widest font-semibold text-sky-brand">Pricing</span>
            <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight text-white mt-5">Choose your plan</h1>
            <p className="font-body text-lg text-white/60 mt-6 max-w-2xl mx-auto">Two simple ways to get your business online — pick the one that fits.</p>
          </Reveal>
        </div>
      </section>

      {/* Cards */}
      <section className="bg-white py-20 md:py-24 -mt-16">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <PricingCards />
        </div>
      </section>
    </div>
  );
}
